import type { IOauthGrantListItemDto } from "@ryde/shared";

/** One connected-apps row, with every label already resolved so the component only renders. */
export interface IConnectedAppRow {
  grant: IOauthGrantListItemDto;
  permissionsLabel: string;
  connectedAtLabel: string;
  lastUsedAtLabel: string;
}

/** Query parameters the MCP connect page reads; the backend owns their meaning. */
export const CONNECT_AGENT_PAGE_QUERY = {
  language: "lang",
  logo: "logo",
} as const;
